import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Box, Typography, Paper, Button } from "@mui/material";
import { Lock as LockIcon, ArrowBack as BackIcon } from "@mui/icons-material";

const SuperAdminRoute = ({ children }) => {
  const { user, loading, isSuperAdmin } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <Typography variant="h6">Loading...</Typography>
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
        sx={{ p: 3 }}
      >
        <Paper elevation={3} sx={{ p: 4, textAlign: "center", maxWidth: 500 }}>
          <LockIcon sx={{ fontSize: 64, color: "error.main", mb: 2 }} />
          <Typography variant="h5" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            You need Super Admin privileges to access this section.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Current role:{" "}
            <strong>{user.role?.replace("_", " ").toUpperCase()}</strong>
          </Typography>
          <Button
            variant="contained"
            startIcon={<BackIcon />}
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>
        </Paper>
      </Box>
    );
  }

  return children;
};

export default SuperAdminRoute;
